import _typeof from "D:/progect/guowai/ex_express_web/node_modules/@babel/runtime/helpers/esm/typeof";
import _objectSpread from "D:/progect/guowai/ex_express_web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import store from '@/store';
import utils from '@/utils';
export default {
  install: function install(Vue) {
    // 快速打印 log
    Vue.prototype.$log = _objectSpread(_objectSpread({}, utils.log), {}, {
      push: function push(data) {
        if (typeof data === 'string') {
          // 如果传递来的数据是字符串
          // 赋值给 message 字段
          // 为了方便使用
          // eg: this.$log.push('foo text')
          store.dispatch('d2admin/log/push', {
            message: data
          });
        } else if (_typeof(data) === 'object') {
          // 如果传递来的数据是对象
          store.dispatch('d2admin/log/push', data);
        }
      }
    });
  }
};